module.exports = __webpack_public_path__ + "static/media/gemelo.e86f049a.png";